/**
 * Recruiter-friendly keyword syntax and sample queries.
 * The API compiles these values; the frontend sends each query unchanged.
 */

export const KEYWORD_OPERATOR_ROWS = [
    {
        syntax: "word1 AND word2",
        meaning: "Both terms must appear",
    },
    {
        syntax: "word1 OR word2",
        meaning: "At least one term must appear",
    },
    {
        syntax: '"civil engineer"',
        meaning: "Search for an exact phrase",
    },
    {
        syntax: "(word1 OR word2)",
        meaning: "Group terms; AND is evaluated before OR",
    },
    {
        syntax: "word*",
        meaning:
            "Prefix wildcard (* only at the end; tokens shorter than ~3 characters may be ignored)",
    },
];

export const KEYWORD_SEARCH_TOPICS =
    "Search covers personal details and preferences, experiences, educations, and recruiter / RP notes. Combine it with structured filters as usual. Greek and Latin terms are supported.";

export const KEYWORD_SEARCH_SAMPLES = [
    {
        domain: "Tech",
        samples: [
            { query: "react AND typescript", intent: "Both technologies" },
            { query: "java OR python", intent: "Either language" },
            { query: "kubernetes*", intent: "Prefix wildcard" },
            {
                query: "react AND (athens OR θεσσαλονίκη)",
                intent: "React and either city",
            },
            {
                query: '"data engineer" AND (AWS OR Azure)',
                intent: "Exact title and either cloud",
            },
        ],
    },
    {
        domain: "Finance",
        samples: [
            {
                query: "controller AND (IFRS OR GAAP)",
                intent: "Controller and either reporting standard",
            },
            {
                query: 'treasury AND "cash flow"',
                intent: "Treasury and an exact phrase",
            },
            { query: "forecast*", intent: "Prefix wildcard" },
            { query: "λογιστής AND finance", intent: "Greek and English terms" },
        ],
    },
    {
        domain: "Engineering",
        samples: [
            {
                query: '("civil engineer" or "civil engineering" or "πολιτικός μηχανικός") and (tendering or tender or διαγωνισμοί or διαγωνισμός or δημόσια or public)',
                intent: "Civil engineering and public tendering",
            },
            {
                query: '("mechanical engineer" OR "mechanical engineering") AND ("MEP" OR "HVAC" OR "electromechanical") AND ("studies" OR "design")',
                intent: "Mechanical engineering, systems, and design",
            },
            {
                query: "electrical AND (PLC OR SCADA)",
                intent: "Electrical and either control system",
            },
            {
                query: '"μηχανολόγος μηχανικός" AND AutoCAD',
                intent: "Greek title and AutoCAD",
            },
        ],
    },
    {
        domain: "Accounting",
        samples: [
            {
                query: "accountant AND (IFRS OR VAT)",
                intent: "Accountant and either standard",
            },
            {
                query: 'SAP AND ("accounts payable" OR "accounts receivable")',
                intent: "SAP and either accounting function",
            },
            { query: "λογιστ*", intent: "Greek prefix wildcard" },
            { query: "audit AND assistant", intent: "Both terms" },
        ],
    },
];
